// extracted by mini-css-extract-plugin
export default {"pitchFade":"_3CJjpqo8"};